<template>
  <div class="dsfa-netcom-login-more" v-if="show">
    <div class="more-tabs">
      <div class="more-tab-navs">
        <div :class="['more-tab-nav', activeName == item.code && 'active']" v-for="(item, index) in tabNav" :key="index" @click="handleTabNav(item)">
          <span v-if="item.enableValue == 1">{{ item.name }}</span>
        </div>
      </div>
      <div :class="['more-tab-plans', showPlan && 'active']">
        <!-- 通知公告 -->
        <div class="more-tab-plan" v-show="activeName == 'announcement'">
          <DsfVirtualScroll>
            <div class="tab-title" v-if="announcementList.length > 0">
              <div><i class="iconfont icon-icon-classType"></i><span class="t">通知公告</span></div>
              <div class="m" @click="clickMore">查看更多 ></div>
            </div>
            <ul class="notice-list" v-if="announcementList.length > 0">
              <li class="notice-item" v-for="(item, index) in announcementList" :key="index" @click="clickMore(item)">
                <span class="more-tab-plan-title ellipsis" :title="item.title">
                  {{ item.title }}
                </span>
                <span class="more-tab-plan-time">
                  {{ dsf.date.format(item.dsCreateTime,'yyyy-mm-dd') }}
                </span>
              </li>
            </ul>
            <DsfEmptyData v-else></DsfEmptyData>
          </DsfVirtualScroll>
        </div>
        <!-- 常用下载 -->
        <div class="more-tab-plan" v-show="activeName == 'downloads'">
          <DsfVirtualScroll>
            <div class="tab-title" v-if="downloadsList.length > 0">
              <div><i class="d iconfont icon-yunduanxiazai"></i><span class="t">常用下载</span></div>
              <div class="m" @click="clickMore">查看更多  ></div>
            </div>
            <ul class="notice-list" v-if="downloadsList.length > 0">
              <li class="notice-item" v-for="(item, index) in downloadsList" :key="index" :title="item.title" @click="handleDownload(item)">
                <span class="more-tab-plan-title ellipsis">
                  {{ item.title }}
                </span>
                <span class="more-tab-plan-time">
                  {{ dsf.date.format(item.fileUpload.uploadDate,'yyyy-mm-dd') }}
                </span>
              </li>
            </ul>
            <DsfEmptyData v-else></DsfEmptyData>
          </DsfVirtualScroll>
        </div>
      </div>
    </div>
    <div class="more-switch" @click="showPlan = !showPlan">
      <i :class="['iconfont', showPlan ? 'icon-shuangjiantouzuo' : 'icon-shuangjiantouyou']"></i>
    </div>
    <!-- <popup-detail ref="popupDetail" @maskSwitch="maskSwitch" /> -->
    <div class="dsfa-sc-login-mask" v-if="showMask" @click="handleMask()"></div>
    <div class="more-download-qrcode" v-if="downloadQrCode.imgUrl" :style="{ top: downloadQrCode.top, left: downloadQrCode.left }">
      <img class="more-download-qrcode-img" :src="dsf.url.getWebPath(downloadQrCode.imgUrl)" />
      <div class="more-download-qrcode-text">请扫码下载应用到手机</div>
    </div>
  </div>
</template>

<script>
// import PopupDetail from "./PopupDetail";

export default {
  name: "NetcomMore",
  data() {
    return {
      activeName: "",
      tabNav: [],
      announcementList: [],
      downloadsList: [],
      wikiList: [],
      showPlan: false,
      popupDetailShow: false,
      showMask: false,
      show: false,
      downloadQrCode: {
        imgUrl: "",
        top: "0px",
        left: "0px",
      },
      detailMore: false,
    };
  },
  watch: {},
  components: {
    // PopupDetail,
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    clickMore(item) {
      this.$emit('detail-more', {
        tabNav: this.tabNav,
        noticeId: item?.id,
        announcementList: this.announcementList,
        downloadsList: this.downloadsList,
        activeName: this.activeName
      })
      // dsf.layer.openWindow("#/pc/platform/announcement/newopen?active=" + this.activeName);
    },
    async init() {
      await this.getNavs();
      const result = Promise.all([this.getNoticeList(), this.getDownloadeList()]);
      result.then(() => {
        let listName = this.tabNav[0]?.code + "List";
        // this.showPlan = this[listName]?.length > 0;
      });
    },
    async getNavs() {
      await dsf.http
        .get(`/downloads/getGateWaySetting`)
        .done(({ data, success, message }) => {
          if (success) {
            // 排序 按照后端返回顺序 显示前 隐藏后
            let tabNav = [];
            let shownav = [];
            let hidenav = [];
            _.each(data, (item) => {
              item.enableValue == 1 ? shownav.push(item) : hidenav.push(item);
            });
            tabNav = shownav.filter((item) => item.code !== "wiki");
            this.tabNav = tabNav;
            this.activeName = tabNav[0]?.code;
            this.show = tabNav[0]?.enableValue == 1;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    async getNoticeList() {
      let status = this.tabNav.find((it) => {
        return it.code == "announcement";
      })?.enableValue;
      if (status != 1) {
        return true;
      }
      let params = {
        pageNum: 1,
        pageSize: 100,
      };
      await dsf.http
        .get(`/announce/getMessageList`, params)
        .done(({ data, success, message }) => {
          if (success) {
            if (data.list?.length > 0) {
              // this.showPlan = true;
            }
            this.announcementList = data.list;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    async getWikeList() {
      let status = this.tabNav.find((it) => {
        return it.code == "wiki";
      })?.enableValue;
      if (status != 1) {
        return true;
      }
      let params = {
        pageNum: 1,
        pageSize: 100,
      };
      await dsf.http
        .get(`/tjy/wiki/getPublicShareList`, params)
        .done(({ data, success, message }) => {
          if (success) {
            this.wikiList = data.list;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    getDownloadeList() {
      let status = this.tabNav.find((it) => {
        return it.code == "downloads";
      })?.enableValue;
      if (status != 1) {
        return true;
      }
      let params = {
        pageNum: 1,
        pageSize: 100,
      };
      dsf.http
        .get(`/downloads/getDownloads`, params)
        .done(({ data, success, message }) => {
          if (success) {
            this.downloadsList = data;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    handleNotice(item) {
      this.$refs.popupDetail.getDetail(item.id);
    },
    handleDownload(item) {
      if (!item.fileUpload?.id) {
        dsf.layer.message("暂无下载地址", false);
        return;
      }
      dsf.layer.message("正在下载");
      dsf.file.download(
        "/file/download",
        {
          files: item.fileUpload.id,
          zipName: item.fileUpload.name,
        },
        item.fileUpload.originalFileName
      );
    },
    handleWike(item) {
      // window.open(location.origin + dsf.url.getWebPath("/s/" + item.code));
      window.open(`${location.origin}/platformasq/s/${item.code}`);
    },
    handleTabNav(item) {
      this.showPlan = true;
      this.activeName = item.code;
    },
    maskSwitch(v) {
      this.showMask = v;
    },
    handleMask() {
      this.$refs.popupDetail.close();
      this.$emit('detail-more', this.activeName)
      this.$emit("detail-close", false);
    },
    mouseenterDownload(e, item) {
      let dom = $(e.target).parent(".download-item-content").find(".download-item-content-btn-wrap")[0];
      if (item.qrCode) {
        let scrollTop = document.documentElement.scrollTop;
        let moreBoxTop = $(".dsfa-netcom-login-more").offset().top - scrollTop;
        let top = $(dom).offset().top - scrollTop;
        let left = $(dom).offset().left;
        if (top < moreBoxTop) {
          top = moreBoxTop;
        }
        this.downloadQrCode = {
          imgUrl: item.qrCode,
          top: top + "px",
          left: left + "px",
        };
      }
      $(e.target).parent(".download-item-content").addClass("active");
    },
    mouseleaveDownload(e) {
      this.downloadQrCode = {
        imgUrl: "",
        top: "0px",
        left: "0px",
      };
      $(e.target).parent(".download-item-content").removeClass("active");
    },
  },
};
</script>

<style lang="scss">
// @import url("../../../assets/styles/pc/login1.scss");
</style>
